






import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import GimmickManager, {GimmickBase} from '@/script/GimmickManager';
import {Action, Getter} from 'vuex-class';

@Component
export default class GimmickImage extends Vue {
  @Prop({ type: String, required: true })
  private target!: string;

  @Action('changeStatus') private changeStatus!: any;
  @Getter('status') private status!: number;
  @Getter('hookTime') private hookTime!: Date;

  private gimmickBase: GimmickBase | null = null;

  private imageUrl: string = '';

  private created() {
    this.gimmickBase = GimmickManager.INSTANCE.gimmickInfo!.baseList.filter((base) => base.name === this.target)[0];
    if (!this.gimmickBase) {
      window.console.error('Illegal target: ' + this.target);
      return;
    }
    this.imageUrl = this.gimmickBase.image;
    for (let status = 1; status <= this.status; status++) {
      this.changeImage(status);
    }
  }

  private onClick() {
    const gimmickHookList = GimmickManager.INSTANCE.gimmickInfo!.hookList.filter((hook) => hook.status === this.status);
    if (!gimmickHookList.length) { return; }

    gimmickHookList.forEach((gimmickHook) => {
      const target = gimmickHook.targetList.filter((t) => t === this.target)[0];
      if (!target) { return; }

      this.changeStatus({ status: gimmickHook.nextStatus });
    });
  }

  @Watch('hookTime')
  private onChangeStatus() {
    this.changeImage(this.status);
  }

  private changeImage(status: number) {
    const gimmickAction = GimmickManager.INSTANCE.gimmickInfo!.actionList.filter(
      (action) => action.status === status,
    )[0];
    if (!gimmickAction) { return; }

    gimmickAction.eventList.forEach((event) => {
      if (event.type === 'image' && event.target === this.target) {
        this.imageUrl = event.image;
      }
    });
  }
}
